import {
  Box,
  Grid,
  LinearProgress,
  Stack,
  SvgIcon,
  Typography,
} from '@mui/material';

import { ReactComponent as Growth } from 'assets/images/ic_growth.svg';
import { ReactComponent as Document } from 'assets/images/ic_document.svg';
import { ReactComponent as Framework } from 'assets/images/ic_framework.svg';

const ComplianceData = (props: any): React.ReactElement => {
  const {
    overallPercentage,
    evidanceCoverage,
    evidanceTotal,
    activeFramework,
  } = props;
  return (
    <Box className="compliance-dataset-wrapper">
      <Grid container className="compliance-array-set">
        <Grid item xs={12} sm={4}>
          <Box className="compliance-coverage-dataset">
            <Stack direction="row">
              <Typography variant="body1">Overall progress</Typography>
              <SvgIcon
                component={Growth}
                inheritViewBox
                className="view-icon"
                fontSize="inherit"
                htmlColor="#76A81F"
              />
            </Stack>
            <Stack direction="row" spacing={3} alignItems="flex-end">
              <Typography variant="h6">{overallPercentage}%</Typography>
              <Typography component="span">Completed</Typography>
            </Stack>
            <Stack direction="column" spacing={3}>
              <LinearProgress value={overallPercentage} variant="determinate" />
            </Stack>
          </Box>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Box className="compliance-outstanding">
            <Stack direction="row">
              <Typography variant="body1">Evidence collected</Typography>
              <SvgIcon
                component={Document}
                inheritViewBox
                className="view-icon"
                fontSize="inherit"
                htmlColor="#76A81F"
              />
            </Stack>
            <Stack direction="column" spacing={3}>
              <Stack direction="row" spacing={2} alignItems="flex-end">
                <Typography variant="h6">{evidanceCoverage}</Typography>
                <Typography component="span">
                  of {evidanceTotal} items
                </Typography>
              </Stack>

              <Typography component="span">
                {evidanceTotal - evidanceCoverage} items remaining
              </Typography>
            </Stack>
          </Box>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Box className="compliance-on-time">
            <Stack direction="row">
              <Typography variant="body1">Active frameworks</Typography>
              <SvgIcon
                component={Framework}
                inheritViewBox
                className="view-icon"
                fontSize="inherit"
                htmlColor="#3D3C42"
              />
            </Stack>
            <Stack direction="column" spacing={3}>
              <Stack direction="row" spacing={2}>
                <Typography variant="h6">{activeFramework}</Typography>
                <Typography component="span">frameworks</Typography>
              </Stack>
              <Typography component="span">
                Tracking evidence requirements
              </Typography>
            </Stack>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ComplianceData;
